<template>
  <div class="flex flex-col items-end ss xxx">
    STORY
  </div>
</template>